import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import { Box, Button, Column, Popover, TextField } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { FilterChip } from '../../FilterChip/FilterChip';
import { currentValue, nextPredicate } from '../../StringMatchChip/StringMatchChip.utils';
import { fieldLabelFor } from './OrStringGroupChip.utils';
export const GetOrStringGroupChipTID = (parentTestId)=>getTestIds(parentTestId);
export const OrStringGroupChip = (param)=>{
    let { testId, field, predicates, tone, onValueChange, onToggleConnector, onRemove } = param;
    const { OrStringGroupChipTestIds } = useMemo(()=>GetOrStringGroupChipTID(testId), [
        testId
    ]);
    const { t } = useLocaleKeys('pages.draftsDashboard.aiSearch');
    const [anchorEl, setAnchorEl] = useState(null);
    const [activeIndex, setActiveIndex] = useState(null);
    const [draftValue, setDraftValue] = useState('');
    const openPopover = (index)=>(event)=>{
            setActiveIndex(index);
            setDraftValue(currentValue(predicates[index]));
            setAnchorEl(event.currentTarget);
        };
    const closePopover = ()=>setAnchorEl(null);
    const apply = ()=>{
        if (activeIndex == null) return;
        const trimmed = draftValue.trim();
        onValueChange(activeIndex, trimmed.length === 0 ? undefined : nextPredicate(trimmed, predicates[activeIndex]));
        closePopover();
    };
    const valueSegments = predicates.map((predicate, index)=>({
            label: currentValue(predicate),
            onClick: openPopover(index),
            biName: 'drafts_ai_search_chip_edit_string_group_value'
        }));
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(FilterChip, {
                testId: testId,
                fieldLabel: fieldLabelFor(field, t),
                valueSegments: valueSegments,
                combinator: tone === 'or' ? t.orConnector() : t.andConnector(),
                onCombinatorToggle: onToggleConnector,
                combinatorBiName: "drafts_ai_search_chip_toggle_string_group_combinator",
                onRemove: onRemove,
                removeBiName: "drafts_ai_search_chip_remove_string_group"
            }),
            /*#__PURE__*/ _jsx(Popover, {
                testId: OrStringGroupChipTestIds.EditPopover(),
                open: anchorEl != null,
                anchorEl: anchorEl,
                onClose: closePopover,
                children: /*#__PURE__*/ _jsx(Box, {
                    padding: 12,
                    children: /*#__PURE__*/ _jsxs(Column, {
                        gap: 8,
                        children: [
                            /*#__PURE__*/ _jsx(TextField, {
                                testId: OrStringGroupChipTestIds.EditTextField(),
                                bi: {
                                    name: 'drafts_ai_search_chip_edit_string_group_value'
                                },
                                value: draftValue,
                                onChange: (event)=>setDraftValue(event.target.value),
                                inputProps: {
                                    onKeyDown: (event)=>{
                                        if (event.key === 'Enter') {
                                            event.preventDefault();
                                            apply();
                                        }
                                    }
                                },
                                autoFocus: true
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                testId: OrStringGroupChipTestIds.ApplyButton(),
                                bi: {
                                    name: 'drafts_ai_search_chip_apply_string_group_value'
                                },
                                onClick: apply,
                                children: t.applyButton()
                            })
                        ]
                    })
                })
            })
        ]
    });
};
